module.exports = __webpack_public_path__ + "img/404.b00738d1.svg";